// import { Star } from 'lucide-react';
// import { FC, useEffect, useState } from 'react';

// interface Testimonial {
//   quote: string;
//   author: string;
//   position: string;
//   company: string;
//   avatar: string;
// }

// const Testimonials: FC = () => {
//   const [activeTestimonial, setActiveTestimonial] = useState<number>(0);

//   const testimonials: Testimonial[] = [
//     {
//       quote: 'I landed an interview at Google in just a week!',
//       author: 'Sarah K.',
//       position: 'Marketing Specialist',
//       company: 'Hired at Google',
//       avatar: '/api/placeholder/40/40',
//     },
//     {
//       quote: 'Boosted my resume from 65 to 94 in minutes.',
//       author: 'Mike T.',
//       position: 'Full-Stack Developer',
//       company: 'Hired at Microsoft',
//       avatar: '/api/placeholder/40/40',
//     },
//     {
//       quote: 'Applied to 5 jobs and got 3 interviews!',
//       author: 'Jessica L.',
//       position: 'Product Manager',
//       company: 'Hired at Amazon',
//       avatar: '/api/placeholder/40/40',
//     },
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
//     }, 8000);
//     return () => clearInterval(interval);
//   }, [testimonials.length]);

//   return (
//     <section id='testimonials' className='py-20 bg-background'>
//       <div className='container mx-auto px-4'>
//         <div className='text-center max-w-2xl mx-auto mb-12'>
//           <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-md text-sm font-medium mb-4'>
//             <span>Success Stories</span>
//           </div>
//           <h2 className='text-3xl lg:text-4xl font-bold mb-4 text-foreground'>
//             From Our Users to Top Companies
//           </h2>
//           <p className='text-lg text-muted-foreground'>
//             See how ResumeReady helped job seekers land interviews.
//           </p>
//         </div>
//         <div className='max-w-4xl mx-auto relative'>
//           <div className='relative h-64 bg-card border border-border rounded-xl p-8 shadow-lg overflow-hidden'>
//             {testimonials.map((testimonial, index) => (
//               <div
//                 key={index}
//                 className={`absolute top-0 left-0 w-full h-full flex items-center p-8 transition-smooth ${
//                   index === activeTestimonial
//                     ? 'opacity-100 translate-x-0'
//                     : index < activeTestimonial
//                     ? 'opacity-0 -translate-x-full'
//                     : 'opacity-0 translate-x-full'
//                 }`}>
//                 <div className='flex flex-col md:flex-row items-start gap-6'>
//                   <div className='w-16 h-16 rounded-full bg-primary/10 border-2 border-primary/20 overflow-hidden'>
//                     <img
//                       src={testimonial.avatar}
//                       alt={testimonial.author}
//                       className='w-full h-full object-cover'
//                     />
//                   </div>
//                   <div>
//                     <div className='flex mb-1'>
//                       {Array(5)
//                         .fill(0)
//                         .map((_, i) => (
//                           <Star
//                             key={i}
//                             size={16}
//                             className='text-primary mr-1'
//                             fill='currentColor'
//                           />
//                         ))}
//                     </div>
//                     <p className='text-xl font-medium mb-4 text-card-foreground'>
//                       "{testimonial.quote}"
//                     </p>
//                     <div>
//                       <p className='font-bold text-card-foreground'>
//                         {testimonial.author}
//                       </p>
//                       <p className='text-sm text-muted-foreground'>
//                         {testimonial.position} • {testimonial.company}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <div className='absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2'>
//               {testimonials.map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => setActiveTestimonial(index)}
//                   className={`h-2 rounded-full transition-smooth ${
//                     index === activeTestimonial
//                       ? 'bg-primary w-8'
//                       : 'bg-muted w-2 hover:bg-primary/50'
//                   }`}
//                   aria-label={`View testimonial ${index + 1}`}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;

import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { FC, useEffect, useState } from 'react';

interface Testimonial {
  quote: string;
  author: string;
  position: string;
  company: string;
  avatar: string;
}

const Testimonials: FC = () => {
  const [activeTestimonial, setActiveTestimonial] = useState<number>(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState<boolean>(true);

  const testimonials: Testimonial[] = [
    {
      quote: 'I landed an interview at Google in just a week after optimizing my resume!',
      author: 'Sarah K.',
      position: 'Marketing Specialist',
      company: 'Hired at Google',
      avatar: '/api/placeholder/40/40',
    },
    {
      quote:
        'Boosted my resume from 65 to 94 in minutes. The AI suggestions were spot-on.',
      author: 'Mike T.',
      position: 'Full-Stack Developer',
      company: 'Hired at Microsoft',
      avatar: '/api/placeholder/40/40',
    },
    {
      quote:
        'Applied to 5 jobs and got 3 interviews! The templates are beautiful and optimized.',
      author: 'Jessica L.',
      position: 'Product Manager',
      company: 'Hired at Amazon',
      avatar: '/api/placeholder/40/40',
    },
    {
      quote:
        'After months of searching with no luck, I rebuilt my resume and landed my dream job.',
      author: 'David R.',
      position: 'Financial Analyst',
      company: 'Hired at JP Morgan',
      avatar: '/api/placeholder/40/40',
    },
    {
      quote:
        'As a career switcher, I was struggling until ResumeSnap helped me highlight my skills.',
      author: 'Alex M.',
      position: 'UX Designer',
      company: 'Hired at Adobe',
      avatar: '/api/placeholder/40/40',
    },
  ];

  // Auto-advance testimonials
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isAutoPlaying) {
      interval = setInterval(() => {
        setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
      }, 8000);
    }

    return () => clearInterval(interval);
  }, [testimonials.length, isAutoPlaying]);

  // Pause auto-play when user interacts with navigation
  const handleManualNavigation = (index: number) => {
    setActiveTestimonial(index);
    setIsAutoPlaying(false);

    // Resume auto-play after 15 seconds of inactivity
    const timer = setTimeout(() => setIsAutoPlaying(true), 15000);
    return () => clearTimeout(timer);
  };

  const goToPrevious = () => {
    const newIndex =
      activeTestimonial === 0 ? testimonials.length - 1 : activeTestimonial - 1;
    handleManualNavigation(newIndex);
  };

  const goToNext = () => {
    const newIndex = (activeTestimonial + 1) % testimonials.length;
    handleManualNavigation(newIndex);
  };

  return (
    <section id='testimonials' className='py-24 bg-background relative'>
      {/* Decorative background elements */}
      <div className='absolute top-0 left-0 right-0 h-40 bg-gradient-to-b from-primary/5 to-transparent opacity-70'></div>

      <div className='container mx-auto px-4 relative z-10'>
        <div className='text-center max-w-2xl mx-auto mb-16'>
          <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-md text-sm font-medium mb-4'>
            <span>Success Stories</span>
          </div>
          <h2 className='text-3xl lg:text-4xl font-bold mb-4 text-foreground'>
            From Our Users to Top Companies
          </h2>
          <p className='text-lg text-muted-foreground'>
            See how ResumeSnap helped job seekers land interviews at leading companies.
          </p>
        </div>

        <div className='max-w-3xl mx-auto relative px-12'>
          {' '}
          {/* Added horizontal padding for navigation buttons */}
          {/* Testimonial Card with Quote Icon */}
          <div className='relative bg-card border border-border rounded-xl p-8 shadow-lg overflow-hidden min-h-[280px]'>
            <div className='absolute top-6 right-8 text-primary/10'>
              <Quote size={80} className='opacity-20' />
            </div>

            {/* Testimonial Slides */}
            <div className='relative h-full'>
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className={`absolute top-0 left-0 w-full transition-all duration-700 ease-in-out ${
                    index === activeTestimonial
                      ? 'opacity-100 translate-x-0 z-10'
                      : index < activeTestimonial
                      ? 'opacity-0 -translate-x-full z-0'
                      : 'opacity-0 translate-x-full z-0'
                  }`}
                  aria-hidden={index !== activeTestimonial}>
                  <div className='flex flex-col md:flex-row items-start gap-6'>
                    {/* Avatar */}
                    <div className='w-16 h-16 rounded-full bg-primary/10 border-2 border-primary/20 overflow-hidden flex-shrink-0'>
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.author}
                        className='w-full h-full object-cover'
                      />
                    </div>

                    {/* Testimonial Content */}
                    <div className='flex-1'>
                      <div className='flex mb-2'>
                        {Array(5)
                          .fill(0)
                          .map((_, i) => (
                            <Star
                              key={i}
                              size={16}
                              className='text-primary mr-1'
                              fill='currentColor'
                            />
                          ))}
                      </div>
                      <p className='text-lg font-medium mb-4 text-foreground'>
                        {' '}
                        {/* Changed from text-card-foreground to text-foreground */}"
                        {testimonial.quote}"
                      </p>
                      <div className='mt-3'>
                        <p className='font-bold text-foreground'>
                          {' '}
                          {/* Changed from text-card-foreground to text-foreground */}
                          {testimonial.author}
                        </p>
                        <p className='text-sm text-muted-foreground'>
                          {testimonial.position} •{' '}
                          <span className='text-primary'>{testimonial.company}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Dots */}
            <div className='absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2'>
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleManualNavigation(index)}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    index === activeTestimonial
                      ? 'bg-primary w-8'
                      : 'bg-muted w-2 hover:bg-primary/50'
                  }`}
                  aria-label={`View testimonial ${index + 1}`}
                  aria-selected={index === activeTestimonial}
                />
              ))}
            </div>
          </div>
          {/* Previous/Next Navigation Buttons - positioned further away from container */}
          <button
            onClick={goToPrevious}
            className='absolute top-1/2 -left-2 transform -translate-y-1/2 bg-card border border-border rounded-full p-2 shadow-md text-foreground hover:text-primary transition-colors'
            aria-label='Previous testimonial'>
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={goToNext}
            className='absolute top-1/2 -right-2 transform -translate-y-1/2 bg-card border border-border rounded-full p-2 shadow-md text-foreground hover:text-primary transition-colors'
            aria-label='Next testimonial'>
            <ChevronRight size={20} />
          </button>
        </div>

        {/* Company Logos */}
        <div className='mt-16 text-center'>
          <p className='text-sm uppercase text-muted-foreground tracking-wide mb-6'>
            Our users have been hired at
          </p>
          <div className='flex flex-wrap justify-center gap-8 md:gap-12 max-w-3xl mx-auto'>
            {['Google', 'Microsoft', 'Amazon', 'Adobe', 'JP Morgan'].map((company) => (
              <div key={company} className='text-lg font-bold text-foreground/60'>
                {company}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
